import React, { useState, useEffect } from "react";
import { Button, Empty } from "antd";

import TableSelectable from "../TableSelectable";
import Table from "../Table";
import SubUserAddModal from "../SubUserAddModal";

import useMembersStore from "../../store/members.store";
import useSubUserStore from "../../store/subUserModal.store";
import useGroupStore from "../../store/groupModal.store";

import "./settings.scss";
import ProjectAddModal from "../ProjectAddModal";
import useProjectStore from "../../store/projectModal.store";
import GroupAddModal from "../groupAddModal";

const currentTeamTitles = [
  "Select",
  "S. No.",
  "User ID",
  "Emp Id",
  "Name",
  "Mobile No.",
  "Email ID",
  "Project",
  "Role",
  "Timesheet Role",  
  "Leave User Role",  
  "Group/BU Name",
  "Active Since",
  "Permission",
];
const currentTeamTitlesNuJobs = [
  "Select",
  "S. No.",
  "User ID",
  "Emp Id",
  "Name",
  "Mobile No.",
  "Email ID",
  "Project",
  "Role",
  "Group/BU Name",
  "Active Since",
  "Permission",
];
const vendorTitles = [
    "S. No.",
    "Name",
    "Mobile No.",
    "Email ID",
    "Address",
    "City",
    "Country",
    "Vendor ID",
    "Vendor Status",
    "Onboarding Date",
    "Credentials",    
    "Vendor Alias",
    "Vendor Rate",
    "Referred By"
];

function Settings() {
    const [currentView, setCurrentView] = useState("team");
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
            
    const { getTeamMembers, getVendors, vendors, teamMembers,
            updateTeamFlag, resetUpdateFlag
     } =
        useMembersStore();

    const { setModalOpen, setCurrentMemberType, removeMember } =
        useSubUserStore();

    const { setModalOpenP,getProjects,resetProjectUpdate,projectUpdateFlag,currentProjects,groupnamelist } = useProjectStore(); 
    const { setModalOpenG,groupUpdateFlag,resetGroupUpdate}  = useGroupStore();

    const projectData = currentProjects?.map((member, idx) => {
        return {
            value:member.projectname,
            label:member.projectname,
        };
    });
   
    useEffect(() => {
        getTeamMembers();
        getVendors();
        getProjects();
    }, []);

    useEffect(() => {
        if(updateTeamFlag){
            getTeamMembers();
            resetUpdateFlag()
        }
    }, [updateTeamFlag]);

    useEffect(() => {
        if(groupUpdateFlag || projectUpdateFlag){
            getProjects();
            resetProjectUpdate();
            resetGroupUpdate()
        }

    }, [projectUpdateFlag || groupUpdateFlag]);


    const teamMembersList =
        teamMembers && teamMembers.length > 0
            ? teamMembers.map((member, idx) => ({
	          select: "",
                  id: idx + 1,
                  memberID: member?.qhuid,
                  empid: member?.emp_id,
                  username: member?.username,
                  contact: member?.contact,
                  email: member?.email,
                  project: member?.project,
                  designation: member?.designation,
                  tspermission:member?.tspermission,
                  leavepermission:member?.leavepermission,
                  leavegroup:member?.leavegroup,
                  onboardingDate: member?.creationdate,
                  permission: member?.permission
        }))
      : [];

    const teamMembersListNuJobs =
        teamMembers && teamMembers.length > 0
            ? teamMembers.map((member, idx) => ({
	          select: "",
                  id: idx + 1,
                  memberID: member?.qhuid,
                  empid: member?.emp_id,
                  username: member?.username,
                  contact: member?.contact,
                  email: member?.email,
                  project: member?.project,
                  designation: member?.designation,
                  leavegroup:member?.leavegroup,
                  onboardingDate: member?.creationdate,
                  permission: member?.permission
        }))
      : [];

    const vendorsList =
        vendors && vendors.length > 0
            ? vendors.map((member, idx) => ({
                  id: idx + 1,
                  username: member?.username,
                  contact: member?.contact,
                  email: member?.email,
                  address: member?.address,
                  vendor_alias: member?.vendor_alias,
                  vendor_rate: member?.vendor_rate,
                  referred_by: member?.referred_by,
                  vendor_status: member?.vendor_status,
                  date_added: member?.date_added,
              }))
            : [];

    const handleAddProjectClick = () => {
        setModalOpenP();
    };    
    const handleAddGroupClick = () => {
        setModalOpenG();
    };             
    const handleAddTeamClick = () => {
        setModalOpen();
        setCurrentMemberType("team");
    };
    const handleAddVendorClick = () => {
        setModalOpen();
        setCurrentMemberType("vendor");
    };

    return (
        <div className="settings-container">
            <div className="settings-btns-wrapper">
                {
                     userDetails.productsignon.toLowerCase().includes("qhrflow")?
                     <>
                        <Button
                            onClick={() => setCurrentView("team")}
                            className={`setting-btn ${
                                currentView === "team" && "setting-btn-active"
                            }`}
                        >
                            Team
                        </Button>                     
                        <Button
                            onClick={() => setCurrentView("vendor")}
                            className={`setting-btn ${
                                currentView === "vendor" && "setting-btn-active"
                            }`}
                        >
                        Vendors
                        </Button>                     
                     </>
                     :<></>
                }
            </div>
            {currentView === "team" ? (
                <div className="members-wrapper">
                    <div style={{display:"flex"}}>
                    <h2 className="members-list-title">Current Users</h2>
                    <div className="members-add-wrapper">
                        <Button
                            onClick={handleAddGroupClick}
                            type="primary"
                            className="members-add-btn"
                        >
                            + Add New BU/Group
                        </Button>                         
                        <Button
                            onClick={handleAddProjectClick}
                            type="primary"
                            className="members-add-btn"
                        >
                            + Add New Project
                        </Button> 
                        {
                            userDetails.productsignon.toLowerCase().includes("qhrflow")?
                            <>
                                <Button
                                    onClick={handleAddTeamClick}
                                    type="primary"
                                    className="members-add-btn"
                                >
                                    + Import Employee Sheet
                                </Button>                             
                            </>
                            :<></>
                        }                       
                        <Button
                            onClick={handleAddTeamClick}
                            disabled={teamMembers?.length <= userDetails.userplanconfig?.numusers ? false : true}
                            type="primary"
                            className="members-add-btn"
                        >
                            {teamMembers?.length <= userDetails.userplanconfig?.numusers ? "+ New User" : "Max Users Added"} 
                        </Button>                       
                    </div>
                    
                    </div>
                    {teamMembers?.length > 0 ? <>
                        {
                             userDetails.productsignon.toLowerCase().includes("qhrflow")?
                             <>
                                <TableSelectable
                                    titleList={currentTeamTitles}
                                    data={teamMembersList}
                                    groupnamelist = {groupnamelist}
                                    projectData = {projectData}
                                />                             
                             </>
                             :<>
                                <TableSelectable
                                    titleList={currentTeamTitlesNuJobs}
                                    data={teamMembersListNuJobs}
                                    groupnamelist = {groupnamelist}
                                    projectData = {projectData}
                                />                             
                             </>
                        }
                    </>: (
                        <Empty style={{ margin: "60px" }} />
                    )}

                  
                </div>
            ) : (
                <div className="members-wrapper">
                    <div style={{display:"flex"}}>
                    <h2 className="members-list-title">Current Vendors</h2>
                    <div className="members-add-wrapper">
                        <Button
                            onClick={handleAddVendorClick}
                            type="primary"
                            className="members-add-btn"
                        >
                            + Add Vendor
                        </Button>
                    </div>
                    </div>
                    {vendors?.length > 0 ? (
	            <Table
	              titleList={vendorTitles}
	              data={vendorsList}
	              columnWidth={[50, 100, 100, 100, 100, 100, 100, 100, 100, 100]}
	            />
                    ) : (
                        <Empty style={{ margin: "60px" }} />
                    )}

                  
                </div>
            )}
            <SubUserAddModal />
            <ProjectAddModal />
            <GroupAddModal />

        </div>
    );
}

export default Settings;
